export async function subscribeToNewsletter(
  endpoint: string,
  email: string
): Promise<void> {
  const response = await fetch(endpoint, {
    body: new URLSearchParams({ email }).toString(),
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    method: "POST",
  });
  if (!response.ok) {
    throw new Error("Newsletter signup failed");
  }
  const result: unknown = await response.json();
  if (
    typeof result !== "object" ||
    result === null ||
    !("success" in result) ||
    result.success !== true
  ) {
    throw new Error("Newsletter signup was not accepted");
  }
}
